var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogisticManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.799,
    height: 40,
    viewBox: "0 0 34.799 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#cedbfc}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(-49 -18.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15917",
    d: "M71.694 43.093l15.593-9-1.641-.948-15.633 9.024z",
    className: "cls-1",
    "data-name": "Path 15917",
    transform: "translate(-19.247 -13.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15918",
    d: "M64.681 169.936v-16.322L63 152.638v18.054l15.634 9.026v-1.727z",
    className: "cls-1",
    "data-name": "Path 15918",
    transform: "translate(-12.823 -123.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15919",
    fill: "#f0b33f",
    d: "M132.581 77.015a.588.588 0 0 0-.294.51v9.937L131.1 86.11a.613.613 0 0 0-.682-.155l-1.238.505V75.373l16.532-9.535-.58-1.019-16.822 9.705a.6.6 0 0 0-.306.51v12.305a.61.61 0 0 0 .837.544l1.651-.68 1.944 2.206a.59.59 0 0 0 1.032-.389V77.864l16.546-9.553-.588-1.019z",
    "data-name": "Path 15919",
    transform: "translate(-72.36 -42.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15920",
    fill: "#002173",
    d: "M83.5 27.847l-16.806-9.706a.588.588 0 0 0-.588 0l-16.812 9.706a.588.588 0 0 0-.294.51v19.411a.588.588 0 0 0 .294.51l16.811 9.706a.589.589 0 0 0 .588 0L83.5 48.277a.588.588 0 0 0 .294-.51V28.356a.588.588 0 0 0-.294-.51zM66.4 19.33l15.633 9.026L66.4 37.381l-15.634-9.025zM50.177 29.374L65.811 38.4v18.055l-15.634-9.027zm16.811 27.081V38.4l15.634-9.027v18.055z",
    "data-name": "Path 15920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticManagement);
export default __webpack_public_path__ + "static/media/LogisticManagement.5f528710c03ae2b19a44f107e279098b.svg";
export { ForwardRef as ReactComponent };